const paymentStatus = {
	Pending: 1,
	Processing: 2,
	Approved: 3,
	Rejected: 4,
	'Charged Back': 5,
};

export default paymentStatus;
